class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.playBtn = this.querySelector('[data-play-btn]');
    this.playBtn.addEventListener('click', this.handlePlay.bind(this));
  }

  handlePlay() {
    this.video.setAttribute('controls', 'controls');
    this.video.play();
    this.playBtn.classList.add('hidden');
  }
}

customElements.define('video-player', VideoPlayer);
